/*
 *  Steps
 *
 *  Version:
 *    1.0.0
 */

const SELECTOR_CONTAINER = '[data-steps]';

document
  .querySelectorAll<HTMLDivElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    const buttons = container.querySelectorAll<HTMLButtonElement>('[data-steps-item-button]');
    const items = container.querySelectorAll<HTMLDivElement>('[data-steps-item]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const handle = button.getAttribute('data-handle');

        items.forEach((item) => {
          const handleMatches = item.getAttribute('data-handle') === handle;
          const itemButtons = item.querySelectorAll<HTMLButtonElement>('[data-steps-item-button]');

          item.classList.toggle('s-steps__item--active', handleMatches);

          itemButtons.forEach((itemButton) => {
            if (!itemButton.classList.contains('step-active')) { return }
            itemButton.focus();
          });
        });
      });
    });
  });
